import { useState } from "react";
import numberOne from "../../../assets/number-1.svg";
import numberTwo from "../../../assets/number-2.svg";
import numberThree from "../../../assets/number-3.svg";

export default function HowItWorks() {
  const [currentTab, setCurrentTab] = useState("companies");

  const handleTab = (value) => {
    setCurrentTab(value);
  };

  return (
    <>
      <section id="how_it_works">
        <div className="container">
          <div className="how-it-works-wrapper">
            <h2>How It Works</h2>
            <div className="works-button-switcher">
              <button
                className={`${currentTab === "companies" ? "active" : ""}`}
                onClick={() => handleTab("companies")}
              >
                For Companies
              </button>
              <button
                className={`${currentTab === "sales" ? "active" : ""}`}
                onClick={() => handleTab("sales")}
              >
                For Candidates
              </button>
            </div>
            <div className="switch-how-steps">
              <div
                className={`switch-how-all tab_1 ${
                  currentTab === "companies" ? "active" : ""
                }`}
              >
                <div className="row-essy">
                  <div className="col-essy-lg-4 col-essy-md-4">
                    <div className="how-it-works-single arrow-col">
                      <img src={numberOne} alt="1" />
                      <h3>Share Your Hiring Needs</h3>
                      <p>
                        Tell us the essentials - the role, level, skills
                        required, and where you’re hiring.
                      </p>
                    </div>
                  </div>
                  <div className="col-essy-lg-4 col-essy-md-4">
                    <div className="how-it-works-single arrow-col">
                      <img src={numberTwo} alt="2" />
                      <h3>Meet Interested Candidates</h3>
                      <p>
                        We shortlist professionals already signed up on the Essy
                        platform who match your criteria and have shown intent
                        to move. Each candidate is pre-screened and confirms
                        interest before you meet them.
                      </p>
                    </div>
                  </div>
                  <div className="col-essy-lg-4 col-essy-md-4">
                    <div className="how-it-works-single">
                      <img src={numberThree} alt="3" />
                      <h3>Hire Efficiently</h3>
                      <p>
                        Every profile you receive belongs to someone ready to
                        engage. You save the time and cost of job boards,
                        sourcing, and chasing people who aren’t looking.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`switch-how-all tab_2 ${
                  currentTab === "sales" ? "active" : ""
                }`}
              >
                <div className="row-essy">
                  <div className="col-essy-lg-4 col-essy-md-4">
                    <div className="how-it-works-single arrow-col">
                      <img src={numberOne} alt="1" />
                      <h3>Set Up Your Profile</h3>
                      <p>
                        Add your background, experience, and what kind of
                        opportunity you’re looking for next.
                      </p>
                    </div>
                  </div>
                  <div className="col-essy-lg-4 col-essy-md-4">
                    <div className="how-it-works-single arrow-col">
                      <img src={numberTwo} alt="2" />
                      <h3>Stay in Control</h3>
                      <p>
                        Your profile is private by default. Before any company
                        sees it, we check with you first. You can also toggle
                        your availability - open to work or not - at any time.
                      </p>
                    </div>
                  </div>
                  <div className="col-essy-lg-4 col-essy-md-4">
                    <div className="how-it-works-single">
                      <img src={numberThree} alt="3" />
                      <h3>Interview with Focus</h3>
                      <p>
                        We only share opportunities that align with your
                        experience and goals, so every conversation has real
                        potential.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
